export function initializeGlobalNavigation() {
  const button = document.querySelector('.hamburger');
  const navigation = document.querySelector('#navigation');

  if (!button || !navigation) return;

  const desktopNavigation = window.matchMedia('(min-width: 768px)');

  const updateDropdownAccessibility = () => {
    navigation.querySelectorAll('.dropdown-toggle').forEach((toggle) => {
      const panel = toggle.nextElementSibling;
      if (!panel?.classList.contains('dropdown-panel')) return;

      panel.inert = !desktopNavigation.matches && !toggle.classList.contains('open');
    });
  };

  const updateNavigationAccessibility = () => {
    if (desktopNavigation.matches) {
      navigation.inert = false;
      navigation.removeAttribute('aria-hidden');
    } else {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      navigation.inert = !isOpen;
      navigation.setAttribute('aria-hidden', String(!isOpen));
    }

    updateDropdownAccessibility();
  };

  button.setAttribute('aria-expanded', 'false');
  navigation.classList.remove('is-open');
  updateNavigationAccessibility();
  desktopNavigation.addEventListener('change', updateNavigationAccessibility);

  button.addEventListener('click', (event) => {
    event.preventDefault();
    const isOpen = button.classList.toggle('is-active');
    button.setAttribute('aria-expanded', String(isOpen));
    button.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    navigation.classList.toggle('is-open', isOpen);
    updateNavigationAccessibility();

    if (!isOpen) {
      navigation.querySelectorAll('.dropdown-toggle.open').forEach((toggle) => {
        toggle.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      });
      updateDropdownAccessibility();
    }
  });

  navigation.querySelectorAll('.dropdown-toggle').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const panel = toggle.nextElementSibling;
      if (!panel?.classList.contains('dropdown-panel')) return;

      const isOpen = toggle.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      updateDropdownAccessibility();

      if (!isOpen) {
        panel.querySelectorAll('.dropdown-toggle.open').forEach((childToggle) => {
          childToggle.classList.remove('open');
          childToggle.setAttribute('aria-expanded', 'false');
        });
        updateDropdownAccessibility();
      }
    });
  });
}
